import { createRoot } from 'react-dom/client';
import App from 'app';

import 'bootstrap';
import 'styles/main.scss';

if (document.getElementById('root')) {
  const root = createRoot(document.getElementById('root'));
  root.render(App());
}
